import { Injectable } from '@angular/core';
import { Context } from 'projects/cross-study-portal-lib/src/public-api';

@Injectable({
  providedIn: 'root',
})
export class ContextService {
  private _context?: Context | null = null;

  set instance(val: Context) {
    this._context = val;
  }

  get instance(): Context {
    if (this._context == null) throw new Error('Context is not set');
    return this._context;
  }
}
